export const news = [
  {
    id: 1,
    title: "《星海航行》票房破十亿，国产科幻再创里程碑",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20sci-fi%20space%20nebula%20and%20starship%20with%20warm%20amber%20and%20teal%20tones%2C%20editorial%20news%20photography%20style%2C%20dramatic%20cosmic%20atmosphere%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=xg-n1&orientation=landscape",
    category: "影视新闻",
    date: "2024-11-08",
    author: "向日葵编辑部",
    summary:
      "上映三周，《星海航行》累计票房正式突破十亿大关，成为本年度表现最亮眼的国产科幻电影，也再次点燃了观众对硬核科幻的期待。",
    content: [
      "由陈屿执导的科幻电影《星海航行》上映第三周，累计票房正式突破十亿元人民币，成为本年度国产电影市场的一大亮眼成绩。影片自上映以来口碑持续走高，多个平台评分稳定在九分以上。",
      "影片讲述了近未来地球资源枯竭后，一支远征队踏上寻找新家园的旅程。制片方在视觉呈现上投入了大量心血，虫洞穿越、星舰设计等场景被观众称为“国产科幻的又一张名片”。",
      "业内人士分析认为，《星海航行》的成功不仅在于视觉奇观，更在于它把宏大的宇宙命题落回到了人与人的情感上。主角程野在旅途中对故乡的思念，成为许多观众讨论的焦点。",
      "据悉，片方已启动续集的筹备工作，故事将延续远征队的航线，探索更深处的星海。具体档期尚未公布，本站将持续关注。",
    ],
    relatedMovieId: 1,
  },
  {
    id: 2,
    title: "《长风渡》高口碑收官，古装剧市场迎来回暖",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20palace%20courtyard%20at%20golden%20hour%20with%20hanging%20lanterns%20and%20silk%20drapes%2C%20warm%20gold%20and%20deep%20red%20tones%2C%20editorial%20photography%2C%20elegant%20historical%20mood%2C%20no%20text&width=800&height=500&seq=xg-n2&orientation=landscape",
    category: "影视新闻",
    date: "2024-11-05",
    author: "向日葵编辑部",
    summary:
      "古装剧《长风渡》日前以高口碑收官，剧中细腻的人物塑造与考究的服化道获得观众一致好评，也让业界重新审视古装题材的创作空间。",
    content: [
      "历时一个月的播出，古装剧《长风渡》于本周迎来收官。该剧以名门嫡女与寒门书生的契约婚姻为切入点，讲述两人在乱世中携手守护一方商路的故事。",
      "与传统古装剧不同，《长风渡》把重心放在了人物关系的细腻刻画上。导演尹涛表示，团队在开拍前用大量时间打磨剧本，希望让每一个角色都有可信的动机。",
      "服化道方面，剧组参考了多个历史时期的服饰资料，力求在美感与考据之间取得平衡。不少观众在社交平台上晒出剧中的造型截图，讨论热度居高不下。",
      "有剧评人指出，近两年古装剧市场经历了明显的降温，《长风渡》的口碑表现或许能为这一类型带来新的启发：扎实的故事，永远是最有效的通行证。",
    ],
    relatedMovieId: 11,
  },
  {
    id: 3,
    title: "深度影评：《城市之光》中的人性光谱",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20rainy%20neon%20city%20street%20at%20night%20with%20warm%20amber%20reflections%20on%20wet%20asphalt%2C%20noir%20editorial%20photography%20style%2C%20moody%20atmosphere%2C%20no%20text&width=800&height=500&seq=xg-n3&orientation=landscape",
    category: "影评",
    date: "2024-10-28",
    author: "影评人 江川",
    summary:
      "《城市之光》不是一部简单的犯罪片。它用一桩悬案为引子，把镜头对准了人性深处那些说不清、道不明的灰色地带。",
    content: [
      "在近年来的华语犯罪片里，《城市之光》是一个特别的存在。它没有把重点放在破案的爽感上，而是花了大量篇幅去呈现“选择”本身。",
      "退休刑警重返警队追查旧案，这个设定并不新鲜。真正打动人的，是影片对细节的耐心：一盏忽明忽暗的路灯、一张被反复摩挲的旧照片、雨夜中不肯熄灭的窗口。",
      "导演韩立在接受采访时说，他想拍的不是“谁是凶手”，而是“人为什么会走到那一步”。这种叙事取向，让影片在类型框架内拥有了一种文学性的厚度。",
      "当然，影片也并非没有争议。有观众认为中段节奏偏慢，线索的铺陈略显克制。但正是这种克制，换来了结尾那场戏的巨大冲击力。",
      "如果你喜欢在罪案之外看到人心的复杂，《城市之光》值得二刷。第一次看故事，第二次看人。",
    ],
    relatedMovieId: 2,
  },
  {
    id: 4,
    title: "暑期档专题：十部不容错过的华语佳作",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20collage%20of%20cinema%20theater%20marquee%20lights%20and%20warm%20sunset%20sky%2C%20golden%20amber%20and%20teal%20tones%2C%20editorial%20feature%20photography%2C%20festive%20summer%20mood%2C%20no%20text&width=800&height=500&seq=xg-n4&orientation=landscape",
    category: "专题活动",
    date: "2024-10-20",
    author: "向日葵专题组",
    summary:
      "这个夏天，华语影坛佳作频出。我们精选了十部兼具口碑与看点的作品，从科幻到现实，承包你的整个观影清单。",
    content: [
      "每到暑期档，影院里总是热闹非凡。今年也不例外，从科幻大片到小成本文艺片，几乎每一种口味都能找到对应的选择。",
      "本次专题我们按照类型整理了十部作品，既有票房与口碑双丰收的《星海航行》，也有以细腻情感见长的《归途列车》。",
      "值得一提的是，今年的现实题材作品表现尤其突出。《归途列车》用一趟绿皮火车的旅程，讲透了父子之间那些说不出口的爱。",
      "此外，奇幻与古装题材同样带来了惊喜。《山海秘境》用宏大的东方想象构建了一个可信的秘境世界，视觉呈现令人耳目一新。",
      "希望这份片单能为你的夏日夜晚提供一些灵感。点击每部影片的链接，即可查看详细介绍与观看指引。",
    ],
    relatedMovieId: 6,
  },
  {
    id: 5,
    title: "《迷雾追凶》第二季正式开机，原班人马回归",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20dim%20detective%20office%20with%20a%20clue%20board%20of%20photos%20and%20red%20threads%2C%20cold%20slate%20and%20amber%20light%2C%20editorial%20photography%2C%20tense%20noir%20mood%2C%20no%20text&width=800&height=500&seq=xg-n5&orientation=landscape",
    category: "影视新闻",
    date: "2024-10-15",
    author: "向日葵编辑部",
    summary:
      "口碑悬疑剧《迷雾追凶》第二季于日前正式开机，导演陈正道携原班人马回归，新一季将延续小城悬案的叙事风格，并引入全新的时间线。",
    content: [
      "凭借第一季的高口碑，《迷雾追凶》成为今年悬疑剧市场的一匹黑马。日前，剧组正式宣布第二季开机，主创阵容基本保持原班人马。",
      "导演陈正道在开机仪式上透露，第二季不会是简单的延续，而会引入一条跨越十年的新时间线，让案件的因果链条更加完整。",
      "主演秦昊表示，新一季的剧本让他在读第一遍时就停不下来：“角色的心理层次比第一季更复杂，演起来很有挑战。”",
      "制作方表示，第二季预计明年与观众见面。更多细节将在后续陆续公布，本站将持续跟进报道。",
    ],
    relatedMovieId: 14,
  },
  {
    id: 6,
    title: "《音乐浪潮》总决赛落幕，素人歌手夺冠",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20concert%20stage%20with%20glowing%20spotlights%20and%20a%20crowd%20silhouette%2C%20deep%20purple%20and%20warm%20gold%20highlights%2C%20editorial%20photography%2C%20electric%20celebratory%20mood%2C%20no%20text&width=800&height=500&seq=xg-n6&orientation=landscape",
    category: "影视新闻",
    date: "2024-08-12",
    author: "向日葵编辑部",
    summary:
      "音乐竞技综艺《音乐浪潮》日前迎来总决赛。来自小城的素人歌手凭借一首原创作品爆冷夺冠，成为本季最大黑马。",
    content: [
      "历经三个月的激烈角逐，音乐竞技综艺《音乐浪潮》终于落下帷幕。总决赛现场，六位选手用一场场高水准的表演，把气氛推向了顶点。",
      "最终，一位来自小城的素人歌手凭借原创作品《回家的人》摘得冠军。他说，这首歌写给了所有在外打拼、却始终惦记着家的人。",
      "节目播出期间，多位选手的表演视频在网络上广泛传播，也让不少素人音乐人走进了大众视野。",
      "制作方表示，《音乐浪潮》的初衷就是给普通人一个舞台。未来节目将继续坚持这一理念，让更多好声音被听见。",
    ],
    relatedMovieId: 20,
  },
  {
    id: 7,
    title: "影评：《山海秘境》——东方奇幻的一次视觉远征",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20misty%20ancient%20mountains%20with%20floating%20islands%20at%20golden%20sunrise%2C%20lush%20green%20and%20warm%20gold%20palette%2C%20editorial%20photography%2C%20epic%20fantasy%20atmosphere%2C%20no%20text&width=800&height=500&seq=xg-n7&orientation=landscape",
    category: "影评",
    date: "2024-09-30",
    author: "影评人 沈砚",
    summary:
      "《山海秘境》把古籍中的想象搬上了银幕。它或许不是完美的电影，但它让观众重新相信，东方奇幻可以拍得如此好看。",
    content: [
      "看《山海秘境》的过程，像是在翻阅一本会动起来的古籍。导演顾长风用大量的镜头语言去呈现山水、云雾与人物的关系，画面本身就有一种古典的美感。",
      "影片的世界观建立在《山海经》的想象之上，但并没有停留在符号的堆砌。人、妖、灵三界的设定，最终都服务于主角的成长。",
      "动作设计是另一大亮点。与传统武侠不同，片中的招式更强调意境与留白，配合飘逸的镜头运动，让打斗场面多了几分诗意。",
      "当然，影片在叙事节奏上仍有提升空间。部分支线的铺陈略显仓促，让世界观没能完全展开。",
      "但瑕不掩瑜。《山海秘境》证明了，只要用心，东方奇幻完全可以成为华语电影的一张独特名片。",
    ],
    relatedMovieId: 3,
  },
  {
    id: 8,
    title: "国庆档前瞻：多部大片集中定档，类型更加多元",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20theater%20red%20seats%20and%20a%20glowing%20blank%20screen%20in%20warm%20amber%20light%2C%20editorial%20cinema%20photography%2C%20anticipatory%20mood%2C%20no%20text&width=800&height=500&seq=xg-n8&orientation=landscape",
    category: "专题活动",
    date: "2024-09-24",
    author: "向日葵专题组",
    summary:
      "国庆档临近，多部备受期待的作品陆续定档。从史诗战争到都市情感，今年的档期类型分布更加均衡，观众的期待值也被拉满。",
    content: [
      "距离国庆档还有一周，各大片方已经陆续公布档期。从目前公布的片单来看，今年的国庆档在类型分布上显得更加均衡。",
      "历史战争题材依然是档期的重要组成。由高希希执导的古装战争剧《大漠孤烟》备受关注，其宏大的战争场面被业内看好。",
      "都市情感与现实题材同样不缺席。《时差恋人》以独特的叙事方式切入现代人的情感困境，有望成为档期里的一匹黑马。",
      "此外，多部合家欢与动画作品也将加入竞争，为家庭观众提供更多选择。",
      "整体来看，今年的国庆档既有体量，也有多样性。谁能在激烈的竞争中脱颖而出，让我们拭目以待。",
    ],
    relatedMovieId: 16,
  },
  {
    id: 9,
    title: "《时差恋人》海外口碑爆棚，多国观众自发安利",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20train%20platform%20at%20golden%20hour%20with%20soft%20warm%20blush%20and%20cream%20tones%2C%20two%20distant%20silhouettes%2C%20editorial%20photography%2C%20bittersweet%20tender%20mood%2C%20no%20text&width=800&height=500&seq=xg-n9&orientation=landscape",
    category: "影视新闻",
    date: "2024-09-10",
    author: "向日葵编辑部",
    summary:
      "都市爱情电影《时差恋人》在海外多个平台上线后收获大量好评，独特的“错位时间”叙事被多国观众自发转发讨论。",
    content: [
      "上映于本月初的《时差恋人》，近日在海外市场意外走红。影片以作息完全错位的两个人为主角，用语音留言串起了一段错过的爱情。",
      "不少海外观众在社交平台上表示，影片对现代人情感困境的捕捉非常精准：“那种明明很想联系，却总是错过的心情，太真实了。”",
      "导演宋知遥回应称，创作初衷源于自己对异地恋的观察。她希望通过这部电影告诉观众，时间也许会对不上，但心意不会。",
      "目前影片仍在持续放映中，海外版权也已售出至多个地区。",
    ],
    relatedMovieId: 5,
  },
  {
    id: 10,
    title: "综艺市场观察：真人秀如何跳出同质化的漩涡",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20television%20studio%20with%20camera%20rigs%20and%20warm%20amber%20stage%20light%2C%20editorial%20production%20photography%2C%20behind%20the%20scenes%20mood%2C%20no%20text&width=800&height=500&seq=xg-n10&orientation=landscape",
    category: "影评",
    date: "2024-08-20",
    author: "影评人 罗薇",
    summary:
      "当观众开始对相似的节目形式感到疲惫，真人秀的破局之道究竟在哪里？本文从近两年的几档节目出发，聊聊综艺创作的可能性。",
    content: [
      "这些年，真人秀的数量持续增长，但真正让人记住的却越来越少。当旅行、选秀、竞技的形式被反复使用，观众的耐心也在被消耗。",
      "值得肯定的是，一些节目开始尝试剥离过度设计的环节，把镜头还给真实。例如《快乐出发吧》就没有脚本，反而收获了不少好评。",
      "《美食奇遇记》则给出了另一种思路：与其堆砌明星，不如讲好人和食物的故事。每一家小馆背后的坚持，本身就足够动人。",
      "当然，创新从来不是一件容易的事。但至少可以确定的是，观众永远愿意为真诚买单。",
      "综艺的下一个风口也许很难预测，但“真实”一定是绕不开的关键词。",
    ],
    relatedMovieId: 19,
  },
];